import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import PlatformBadges from '../components/PlatformBadges';
import Problem from '../components/Problem';
import MissionStats from '../components/MissionStats';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Comparison from '../components/Comparison';
import Process from '../components/Process';
import SocialContent from '../components/SocialContent';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import Blog from '../components/Blog';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SectionStroke from '../components/PageStroke';

const HomePage = () => {
  return (
    <main className="min-h-screen bg-[#F4F4F3]">
      <Header />
      <Hero />
      <Marquee />
      <PlatformBadges />

      {/* Curve 1 — right-drifting sweep */}
      <div className="bg-[#F4F4F3] py-4 px-6 sm:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto h-32 sm:h-40">
          <SectionStroke
            d="M 8,90 Q 140,20 240,60 T 396,20"
            viewBox="0 0 400 120"
            color="#AA94FF"
            opacity={0.95}
            strokeWidth={26}
            className="h-full"
          />
        </div>
      </div>

      <Problem />
      <MissionStats />

      {/* Curve 2 — pink S-curve to the right */}
      <div className="bg-[#F4F4F3] py-4 px-6 sm:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto h-32 sm:h-44 flex justify-end">
          <div className="w-3/4">
            <SectionStroke
              d="M 4,20 C 100,90 200,10 280,70 S 380,90 396,40"
              viewBox="0 0 400 120"
              color="#FFA8F2"
              opacity={0.9}
              strokeWidth={28}
              className="h-full"
            />
          </div>
        </div>
      </div>

      <Services />
      <Portfolio />

      {/* Curve 3 — lavender wave */}
      <div className="bg-[#F4F4F3] py-4 px-6 sm:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto h-32 sm:h-44">
          <SectionStroke
            d="M 4,80 Q 160,-10 260,80 T 396,30"
            viewBox="0 0 400 120"
            color="#AA94FF"
            opacity={0.9}
            strokeWidth={26}
            className="h-full"
          />
        </div>
      </div>

      <Comparison />
      <Process />
      <SocialContent />

      {/* Curve 4 — orange gentle wave, half width, centred */}
      <div className="bg-[#F4F4F3] py-4 px-6 sm:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto h-28 sm:h-36 flex justify-center">
          <div className="w-2/3">
            <SectionStroke
              d="M 4,60 Q 120,110 200,50 T 396,70"
              viewBox="0 0 400 120"
              color="#FFA952"
              opacity={0.9}
              strokeWidth={24}
              className="h-full"
            />
          </div>
        </div>
      </div>

      <About />

      {/* Curve 5 — before testimonials, right-aligned pink hook */}
      <div className="bg-[#F4F4F3] py-4 px-6 sm:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto h-24 sm:h-32">
          <SectionStroke
            d="M 4,40 C 100,10 180,110 260,50 S 380,20 396,80"
            viewBox="0 0 400 120"
            color="#AA94FF"
            opacity={0.85}
            strokeWidth={22}
            className="h-full"
          />
        </div>
      </div>

      <Testimonials />
      <Blog />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
};

export default HomePage;
